// services/cc.js
import axiosInstance from './axiosInstance';

const CC_API_URL = '/cc';

const ccService = {
  async get(idempresa, filters = {}) {
    try {
      const { days, customerId, startdate, enddate } = filters;
      let url = `${CC_API_URL}/get.php?idempresa=${idempresa}`;
      
      if (days !== undefined) {
        url += `&days=${days}`;
      }
      
      if (customerId) {
        url += `&customerId=${customerId}`;
      }
      
      if (startdate !== undefined && startdate !== null && startdate >= 946684800) {
        url += `&startdate=${startdate}`;
      }
      
      if (enddate !== undefined && enddate !== null && enddate >= 946684800) {
        url += `&enddate=${enddate}`;
      }
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter documentos pendentes:', error);
      throw error;
    }
  }
};

export default ccService;
